import _WidgetBaseSP from 'more/_WidgetBaseSP';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FreightOccupationView.html?raw';
import EntityStore from '../../../moreCore/Tools/EntityStore';

 

interface freight { internalName: string, label?: string, value: number, clickFct?: Function };
class TiFreightOccupationView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private availableSpaceContainer: HTMLElement;
    private usedSpaceContainer: HTMLElement;
    

    private availableSpacesStore: MdsLax<InstanceType<typeof EntityStore<freight>>>;
    private usedSpacesStore: MdsLax<InstanceType<typeof EntityStore<freight>>>;

    valueSuffix: string = "";
    valuePrefix: string = "";
    valueFractionDigitsDisplayed: number = 2;

    iconAvailableBar: string = "";
    iconUsedBar: string = "";

    removeSpace(internalName?: string) {
        if (internalName) this.availableSpacesStore.deleteEntry(internalName);
        else this.availableSpacesStore.reset();

        this.drawData();
    }

    removeCargo(internalName?: string) {
        if (internalName) this.usedSpacesStore.deleteEntry(internalName);
        else this.usedSpacesStore.reset();

        this.drawData();
    }
    addAvailableSpace(space: freight) {
        if (!space?.value) return;

        this.availableSpacesStore.addEntry(space);

        this.drawData();
    }

    addCargo(cargo: freight) {
        if (!cargo?.value) return;

        this.usedSpacesStore.addEntry(cargo);

        this.drawData();
    }

    isExceededSpace(): boolean {
        let availableList = this.availableSpacesStore.getCurrentCompleteList();
        let cargolist = this.usedSpacesStore.getCurrentCompleteList();

        // summen bilden!
        let sumAvailable = 0;
        for (let space of availableList) {
            sumAvailable += space.value;
        }

        let sumNeeded = 0;
        for (let cargo of cargolist) {
            sumNeeded += cargo.value;
        }

        if (sumNeeded > sumAvailable) {
            return true;
        }

        return false;
    }

    private drawData() {
        this.UiModder.domConstruct.empty(this.availableSpaceContainer);
        this.UiModder.domConstruct.empty(this.usedSpaceContainer);

        this.UiModder.domClass.add(this.availableSpaceContainer, "noSpace");
        this.UiModder.domClass.add(this.usedSpaceContainer, "noCargo");

        let availableList = this.availableSpacesStore.getCurrentCompleteList();
        let cargolist = this.usedSpacesStore.getCurrentCompleteList();

        // summen bilden!
        let biggerValue = -1;
        let sumAvailable = 0;
        for (let space of availableList) {
            sumAvailable += space.value;
        }

        let sumNeeded = 0;
        for (let cargo of cargolist) {
            sumNeeded += cargo.value;
        }

        if (sumAvailable > biggerValue) biggerValue = sumAvailable;
        if (sumNeeded > biggerValue) {
            biggerValue = sumNeeded;
            this.UiModder.domClass.add(this.domNode, "exceeded");
        } else {
            this.UiModder.domClass.remove(this.domNode, "exceeded");
        }

        if (!availableList.length) {
            let node = this.UiModder.domConstruct.create("div", {
                className: "bar noSpace",
            }, this.availableSpaceContainer);
        } else {
            // falls mehr Platz benötigt wird als verfügbar, Fake-Element in die Liste, da den fehlenden Platz darstellen wird:
            if (sumNeeded > sumAvailable) {
                availableList.push({
                    internalName: "missing",
                    value: biggerValue - sumAvailable,
                });
            } else if (sumAvailable > sumNeeded) {
                cargolist.push({
                    internalName: "empty",
                    value: biggerValue - sumNeeded,
                });
            }
        }

        for (let space of availableList) {
            this.UiModder.domClass.remove(this.availableSpaceContainer, "noSpace");

            let node = this.UiModder.domConstruct.create("div", {
                className: "space bar",

            }, this.availableSpaceContainer);

            let valueStr = space.value.toFixed(this.valueFractionDigitsDisplayed);
            if (this.valuePrefix) valueStr = this.valuePrefix + valueStr;
            if (this.valueSuffix) valueStr += this.valueSuffix;

            if (this.iconAvailableBar) valueStr = this.createFontawesomeIcon(this.iconAvailableBar, "&nbsp;").outerHTML + valueStr;

            this.UiModder.domConstruct.create("label", {
                innerHTML: valueStr,
                className: "value"
            }, node);

            if (space.label) {

                this.UiModder.domConstruct.create("label", {
                    innerHTML: space.label,
                    className: "label"
                }, node);
            }

            if (space.internalName == "missing") {
                this.UiModder.domClass.add(node, "missing");
                this.UiModder.domClass.remove(node, "space");
                node.innerHTML = this.createFontawesomeIcon("fas fa-triangle-exclamation").outerHTML;
            }

            if (space.clickFct) {
                this.UiModder.domClass.add(node, "clickable hoverBright");
                on(node, "click", space.clickFct);
            }
            // wie viel ist das anteilig zur maximalen Breite?
            let ratio = space.value * 100 / biggerValue;

            node.style.setProperty("--ratio", ratio.toFixed(4) + "%");
        }

        for (let cargo of cargolist) {
            this.UiModder.domClass.remove(this.usedSpaceContainer, "noCargo");

            let node = this.UiModder.domConstruct.create("div", {
                className: "cargo bar",

            }, this.usedSpaceContainer);

            let valueStr = cargo.value.toFixed(this.valueFractionDigitsDisplayed);
            if (this.valuePrefix) valueStr = this.valuePrefix + valueStr;
            if (this.valueSuffix) valueStr += this.valueSuffix;

            if (this.iconUsedBar) valueStr = this.createFontawesomeIcon(this.iconUsedBar, "&nbsp;").outerHTML + valueStr;

            this.UiModder.domConstruct.create("label", {
                innerHTML: valueStr,
                className: "value"
            }, node);

            if (cargo.label) {

                this.UiModder.domConstruct.create("label", {
                    innerHTML: cargo.label,
                    className: "label"
                }, node);
            }

            if (cargo.internalName == "empty") {
                this.UiModder.domClass.add(node, "empty");
                this.UiModder.domClass.remove(node, "cargo");
                node.innerHTML = "";
            }

            if (cargo.clickFct) {
                this.UiModder.domClass.add(node, "clickable hoverBright");
                on(node, "click", cargo.clickFct);
            }
            let ratio = cargo.value * 100 / biggerValue;

            node.style.setProperty("--ratio", ratio.toFixed(4) + "%");

        }

        //console.debug(this.id, availableList, cargolist);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.availableSpacesStore = new EntityStore();
        this.availableSpacesStore.setup([], "internalName")

        this.usedSpacesStore = new EntityStore();
        this.usedSpacesStore.setup([], "internalName")
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);

       
    }

}

export default mdsWidget(TiFreightOccupationView);